import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Layout } from 'antd';
import HomePage from './components/HomePage';
import TextAnalyzer from './components/TextAnalyzer';
import PaymentPage from './components/PaymentPage';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import axios from 'axios';
import PaymentSuccess from './components/PaymentSuccess';

const { Content } = Layout;

function App() {
  const [user, setUser] = useState(null); // State to manage user
  const [tokenChange, setTokenChange] = useState(false);
  const [tokens, setTokens] = useState(0);

  const backend = 'https://backend-next-level-tutor.onrender.com';
  //const backend = 'http://127.0.0.1:5000';

    useEffect(() => {
    const fetchTokens = async () => {
      try {

        if (user && user?.uid) {
          const response = await axios.get(`${backend}/get-tokens`, {
            params: {
              user_id: user.uid, // Pass user_id as a query parameter
            },
          });
          if(response?.data?.payment_details?.is_subscribed) {
            setTokens(Infinity)
          } else {
            setTokens(response?.data?.payment_details?.token_count || 0);
          }
        }
      } catch (error) {
        console.error('Error fetching tokens:', error);
      }
    };

    fetchTokens();
  }, [tokenChange, user]); // Re-run when `tokenChange` updates

  return (
    <Router>
      <Header
        user={user}
        setUser={setUser}
      />
      <Layout className="app-layout">
        <Content className="app-content">
            {user &&  (
          <div className="logo-token-container">
              <div className="token-count">
                <span>{tokens}</span>
              </div>
            <img src="token_logo.png" alt="Next Level Tutors" className="logo-to" />
          </div>
            )}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/analyze"
              element={
                <TextAnalyzer
                  setTokenChange={setTokenChange}
                  tokenChange={tokenChange}
                />
              }
            />
            <Route path="/buy-tokens" element={<PaymentPage />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Routes>
        </Content>
      </Layout>
      <Footer />
    </Router>
  );
}

export default App;
